import AppUtilities from "@toothfairy/shared-ui/AppUtilities";

export const TRIGGER_TYPE_VALUES = ["ANALYTICS", "SYSTEM", "CUSTOM"];
export const SEVERITY_VALUES = ["info", "warning", "critical"];
export const OPERATOR_VALUES = [
  "eq",
  "neq",
  "gt",
  "gte",
  "lt",
  "lte",
  "contains",
  "not_contains",
];

export const emptyAlert = () => ({
  name: "",
  description: "",
  triggerType: "ANALYTICS",
  severity: "warning",
  isActive: true,
  cooldownMinutes: 0,
  conditions: [{ field: "", op: "eq", value: "" }],
  recipients: [],
  recipientEmails: "",
  notifyEmail: true,
  notifyPush: true,
  notifyInApp: true,
  notifyWebhook: true,
});

export const fromRecord = (record, workspaceUsers) => {
  if (!record) return emptyAlert();
  let conditions = [];
  try {
    conditions =
      typeof record.conditions === "string"
        ? JSON.parse(record.conditions)
        : record.conditions || [];
  } catch (e) {
    conditions = [];
  }
  let recipientIds = [];
  try {
    recipientIds =
      typeof record.recipients === "string"
        ? JSON.parse(record.recipients)
        : record.recipients || [];
  } catch (e) {
    recipientIds = [];
  }
  let recipientEmails = [];
  try {
    recipientEmails =
      typeof record.recipientEmails === "string"
        ? JSON.parse(record.recipientEmails)
        : record.recipientEmails || [];
  } catch (e) {
    recipientEmails = [];
  }
  const enhancedRecipients = (recipientIds || [])
    .map((uid) => {
      const u = workspaceUsers?.find((w) => w.id === uid);
      if (!u) return null;
      return {
        ...u,
        value: u.id,
        label: u?.username || u?.user_email,
        category: "user",
        backgroundColor: AppUtilities.stringToHslColor(
          u?.username || u?.user_email,
          71,
        ),
      };
    })
    .filter((u) => u != null);
  return {
    ...emptyAlert(),
    id: record.id,
    _version: record._version,
    name: record.name || "",
    description: record.description || "",
    triggerType: record.triggerType || "ANALYTICS",
    severity: record.severity || "warning",
    isActive: record.isActive !== false,
    cooldownMinutes: record.cooldownMinutes || 0,
    conditions:
      conditions.length > 0
        ? conditions.map((c) => ({
            field: c.field || "",
            op: c.op || "eq",
            value: c.value ?? "",
          }))
        : [{ field: "", op: "eq", value: "" }],
    recipients: enhancedRecipients,
    recipientEmails: Array.isArray(recipientEmails)
      ? recipientEmails.join(",")
      : "",
    notifyEmail: record.notifyEmail !== false,
    notifyPush: record.notifyPush !== false,
    notifyInApp: record.notifyInApp !== false,
    notifyWebhook: record.notifyWebhook !== false,
  };
};

export const coerceValue = (op, raw) => {
  if (raw === "" || raw === null || raw === undefined) return "";
  if (["gt", "gte", "lt", "lte"].includes(op)) {
    const n = Number(raw);
    return isNaN(n) ? raw : n;
  }
  const lower = String(raw).trim().toLowerCase();
  if (lower === "true") return true;
  if (lower === "false") return false;
  return raw;
};

export const buildAlertInput = (v, workspaceID) => {
  const conditions = (v.conditions || [])
    .filter((c) => c.field && c.field.trim() !== "")
    .map((c) => ({
      field: c.field,
      op: c.op || "eq",
      value: coerceValue(c.op, c.value),
    }));
  const recipientEmails = (v.recipientEmails || "")
    .split(",")
    .map((e) => e.trim())
    .filter((e) => e);
  return {
    name: v.name,
    description: v.description || null,
    triggerType: v.triggerType,
    conditions: JSON.stringify(conditions),
    severity: v.severity || null,
    isActive: v.isActive !== false,
    cooldownMinutes: v.cooldownMinutes ? Number(v.cooldownMinutes) : 0,
    recipients:
      v.recipients?.map((u) => u?.id || u?.value)?.filter((u) => u) || [],
    recipientEmails,
    notifyEmail: v.notifyEmail !== false,
    notifyPush: v.notifyPush !== false,
    notifyInApp: v.notifyInApp !== false,
    notifyWebhook: v.notifyWebhook !== false,
    workspaceID,
  };
};
